import React from "react";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Autocomplete from "components/Autocomplete/Select.jsx";
import Button from "components/CustomButtons/Button.jsx"

// import TestPageSub1 from "./PageTestSub1";
import {APIGet,APIPost} from "APIAxios" 
import * as Alert from "alertService"
import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
 
class PageTest2Page extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dataSelect:null,
      name:"Hi"
    }
  }
  handleChangeSelect = name => value => {
    console.log("Leaf >>>",name,value)
    this.setState({
      [name]: value,
    },()=>{
      this.setState({
        name: JSON.stringify(value),
      })
    });
  };
  handleChange = (name, value) => {
    this.setState({
      [name]: value,
    });
  };
  handleClick = () =>{
    APIPost("api/ping",{},(data)=>{
      console.log("APIGet >>>",data)
      Alert.Success(JSON.stringify(data))
    })
    // APIGet("api/ping/sarawoot",(data)=>{
    //   console.log("APIGet >>>",data)
    //   Alert.Success(JSON.stringify(data))
    // })
  }
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.container + " fullWidth"}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={11}>
            <Card testimonial>
              <div >
                <h1>Page Test</h1>
              </div>
              <CardBody>
                 
                {this.state.name} 
                <center>
                  <Button
                    onClick={ e => { this.handleClick() }}
                  >
                    Call API
                  </Button>
                </center>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(loginPageStyle)(PageTest2Page);
